import React from 'react';
import { LayoutProps } from '../types';
import SeoHead from './SeoHead';
import { useI18n } from '../i18n';
import { en, km } from './Layout.copy';

const Layout: React.FC<LayoutProps> = ({
  children,
  title,
  description,
  keywords,
  canonicalPath,
  image,
  noIndex,
  ogType = 'website',
}) => {
  const { locale } = useI18n();
  const copy = locale === 'km' ? km : en;
  const resolvedTitle = title ?? copy.defaultTitle;
  const resolvedDescription = description ?? copy.defaultDescription;
  const path = canonicalPath ?? '/blog';

  return (
    <>
      <SeoHead
        title={resolvedTitle}
        description={resolvedDescription}
        keywords={keywords}
        path={path}
        image={image}
        noIndex={noIndex}
        type={ogType}
      />
      {children}
    </>
  );
};

export default Layout;
